module.exports = __webpack_public_path__ + "img/27.cb22cfb9.jpg";